import { GLOBAL, redirect } from 'saddlebag-browser';
import { param } from 'saddlebag-url';

import { formatDateNonlocalised } from '../../bootstrap/localisation';
import buildUrl, {
  type UrlBuilderStrings,
  type UrlContext,
} from '../URLBuilder/url-builder';

import logGaEvent from './ga-tracking';
import inputParamChanged from './input-param-changed';

import type {
  CallbackTranslations,
  Callbacks,
  GetResultUrl,
  NavigateToResultUrl,
  NavigateToUrl,
  TripType,
} from './types';
import type { FareAttribute } from '@skyscanner-internal/global-components/types/fareAttributes';

const getCallbacks = (
  originId?: string,
  destinationId?: string,
  tripType?: TripType,
  _adultsV2?: number | null,
  cabinclass?: string,
  _childrenV2?: number | number[] | null,
  translations: CallbackTranslations = {},
  outboundAlts?: boolean,
  inboundAlts?: boolean,
  fareAttributes?: FareAttribute[],
): Callbacks => {
  const getResultUrl: GetResultUrl = (
    outboundDate,
    inboundDate,
    preferDirects,
    stay,
  ) => {
    const initialContext = {
      destinationId,
      originId,
      inboundAlts,
      outboundAlts,
      outboundDate: formatDateNonlocalised(outboundDate),
      inboundDate: inboundDate ? formatDateNonlocalised(inboundDate) : null,
      preferDirects,
      tripType,
      adultsV2: stay.adults,
      cabinclass,
      childrenV2: stay.childrenAges,
      fareAttributes,
    };
    return buildUrl(
      translations.ums as UrlBuilderStrings,
      initialContext as UrlContext,
    );
  };

  const navigateToResultUrl: NavigateToResultUrl = (
    outboundDate,
    inboundDate,
    preferDirects,
    stay,
    prevProvider,
    prevCurrency,
    prevPrice,
    priceSourceId,
    priceTrace,
    openInNewTab = true,
    departureTimeRange = undefined,
  ) => {
    const win = GLOBAL.getWindow();
    const url = getResultUrl(outboundDate, inboundDate, preferDirects, stay);
    const extraParams: Record<string, string | number> = {
      qp_prevProvider: prevProvider,
      qp_prevCurrency: prevCurrency,
      qp_prevPrice: prevPrice,
      priceSourceId,
      priceTrace,
    };
    if (departureTimeRange && departureTimeRange !== '') {
      extraParams['departure-times'] = departureTimeRange;
    }
    win.setTimeout(
      () =>
        redirect(
          `${win.location.protocol}//${win.location.host}${url}&${param(
            extraParams,
            true,
          )}`,
          openInNewTab,
        ),
      200,
    );
  };

  const navigateToUrl: NavigateToUrl = (url, openInNewTab = true) => {
    const win = GLOBAL.getWindow();
    win.setTimeout(
      () =>
        redirect(
          `${win.location.protocol}//${win.location.host}${url}`,
          openInNewTab,
        ),
      200,
    );
  };

  return {
    getResultUrl,
    navigateToResultUrl,
    navigateToUrl,
    getHelpUrl: () => '/',
    reloadPage: () => alert('Reloading page!'), // eslint-disable-line no-alert
    inputParamChanged,
    logGaEvent,
  };
};

export default getCallbacks;
